var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 32,
    viewBox: "0 0 68 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_43957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8391 10.6705L49.3013 3.13267C46.3175 0.227445 41.5278 0.148926 38.6226 3.13267L29.9855 11.7698V17.9729C29.9855 18.9936 29.1217 19.8573 28.101 19.8573C27.0802 19.8573 26.2165 18.9936 26.2165 17.9729V15.5388L19.3853 22.3699C18.9927 22.7625 18.5216 22.9196 18.0505 22.9196C17.5794 22.9196 17.1083 22.7625 16.7157 22.3699C16.009 21.6633 16.009 20.4855 16.7157 19.7003L20.4061 16.0099L23.4683 12.8691H21.1128C20.092 12.8691 19.2283 12.0054 19.2283 10.9846C19.2283 9.96387 20.092 9.10015 21.1128 9.10015H27.2373C29.1217 6.90161 28.9647 3.68231 26.9232 1.6408C24.8032 -0.479225 21.2698 -0.479225 19.1498 1.6408L10.1985 10.592C8.78519 12.0054 8 13.8899 8 15.9314C8 17.9729 8.78519 19.8573 10.1985 21.2707L17.7364 28.8086C20.7202 31.7923 25.5099 31.7923 28.4151 28.8086L43.9619 13.2617L44.5116 12.7906H41.9989C40.9782 12.7906 40.193 12.0054 40.193 10.9846C40.193 9.96387 40.9782 9.17868 41.9989 9.17868H48.9087C49.9294 9.17868 50.7146 9.96387 50.7146 10.9846V17.8944C50.7146 18.9151 49.9294 19.7003 48.9087 19.7003C47.8879 19.7003 47.1027 18.9151 47.1027 17.8944V15.4602L46.5531 16.0099L40.0359 22.527C37.9159 24.647 37.9159 28.1804 40.0359 30.3004C41.1352 31.3997 42.5486 31.9493 43.9619 31.9493C45.3753 31.9493 46.7886 31.3997 47.8879 30.3004L56.8391 21.3492C58.2525 19.9359 59.0377 18.0514 59.0377 16.0099C59.0377 13.9684 58.2525 12.0839 56.8391 10.6705Z",
    fill: "#F5896B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_43957"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0507812,
    width: 67.0377,
    height: 31.8986,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogoMobile);
export default __webpack_public_path__ + "static/media/NavbarLogoMobile.b10a2c998c0b2871c26c62414e90d9fa.svg";
export { ForwardRef as ReactComponent };